import { CommonModule, Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { GlobalSpinnerActions } from '../../ui-kit/global-spinner/actions-types';
import { Subscription, interval } from 'rxjs';

@Component({
    selector: 'app-login-page',
    imports: [CommonModule],
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit, OnDestroy {
  isIframe = window.self !== window.top
  isGlobalSpinnerHidden = true
  constructor(private readonly location: Location,
    private readonly appStore: Store) {
  }
  ngOnInit() {
    if (!this.isIframe) {
      const newUrl = `/?showLeftSideNav=true`
      this.location.replaceState(newUrl)
    }
    else {
      this.appStore.dispatch(GlobalSpinnerActions.showGlobalSpinner())
      this.isGlobalSpinnerHidden = false
    }
  }
  ngOnDestroy() {
    console.log('ondestroy!!!')
    this.appStore.dispatch(GlobalSpinnerActions.hideGlobalSpinner());
    this.isGlobalSpinnerHidden = true
  }
}
